import { DecorationModel } from "../_model/DecorationModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { COLORS } from "../../utils/colors"
import * as d3 from "d3";
import Resize from "../_decorationTools/risezeClass";

export class DecorationAreaJoker extends DecorationModel {
    constructor() {
        super("DecorationAreaJoker");

        this.node = null;
        this.moved = false;
        let resize = new Resize();

        this.init = async function(newNode, openDialog, openArea) {
            let svg = SingletonFlowchart.svg;
            this.dialog = openDialog;
            this.node = newNode;
            this.openArea = openArea

            await svg
                .data([newNode])
                .append("g")
                .attr("id", `${newNode.idName}`)
                .on("mouseover", resize.mouseOver)
                .on("mouseout", resize.mouseOut)
                .call(this.setDrag(newNode))

            let g = d3.select(`#${newNode.idName}`);

            g.append("rect")
                .attr("width", newNode.width)
                .attr("height", newNode.height)
                .attr("fontSize", newNode.fontSize)
                .attr("x", (d) => d.x)
                .attr("y", (d) => d.y)
                .style("fill", "#0000")
                .style("stroke", COLORS.OrangePentagro1)
                .on("click", newNode.readOnly ? this.setOpenDialog(newNode, openDialog, openArea) : () => {})
                .on("dblclick", this.setOpenDialog(newNode, openDialog, openArea))

            g.append("text")
                .text(newNode.areaName)
                .classed("selectable", true)
                .style("font-size", `${newNode.fontSize}px`)
                .style("color", COLORS.White)
                .attr("x", (d) => d.xText())
                .attr("y", (d) => d.yText())
                .style("cursor", "pointer")
                .on("click", newNode.readOnly ? this.setOpenDialog(newNode, openDialog, openArea) : () => {})
                .on("dblclick", this.setOpenDialog(newNode, openDialog, openArea))

            resize.apply(g, newNode)

            return svg;
        };

        this.setOpenDialog = function(d, openDialog, openArea){
          if(d.readOnly && d.wasSet)
              return () => openArea(d.areaName)
          return () => openDialog(d)
        }

        this.setDrag = function() {
            if (this.node.readOnly) return d3.drag();

            let that = this;
            let drag = d3
                .drag()
                .on("start", that.dragstarted)
                .on("drag", (event, d) => that.dragged(event, d, that))
                .on("end", (event, d) => that.dragended(d, that));
            return drag;
        };

        this.dragstarted = function(event, d) {
            SingletonFlowchart.selectNode(`${d.idName}`);

            d3.select(`#${d.idName} > text`)
                .style("cursor", "grabbing");

            d3.select(`#${d.idName} > rect`)
                .style("cursor", "grabbing");

            d3.selectAll(`#AreaJoker-${d.id} > .circleBox`).remove();
        };

        this.dragged = async function(event, d) {
            SingletonFlowchart.clicked = false;
            d.x = event.x;
            d.y = event.y;

            this.move()
        };

        this.move = async function() {
            let d = this.node;

            await d3
                .select(`.${d.idName}`)
                .raise()
                .attr("x", d.x)
                .attr("y", d.y);

            await d3
                .select(`#${d.idName} > text`)
                .raise()
                .attr("x", d.xText())
                .attr("y", d.yText());

            await d3
                .select(`#${d.idName} > rect`)
                .raise()
                .attr("x", d.x)
                .attr("y", d.y);

            resize.move(d)

        };

        this.dragended = function(node) {
            d3.select(`#${node.idName} > rect`)
                    .style("cursor", "grab")

            d3.select(`#${node.idName} > text`)
                    .style("cursor", "pointer")

            if (this.moved) {
                SingletonFlowchart.SaveStatus();
                this.moved = false;
            }
        };

        this.setAdjustArea = function (){
            let d = this.node;
            
            d3.select(`#${d.idName} > rect`)
                .attr("width", d.width)
                .attr("height", d.height)
                .attr("fontSize", d.fontSize)

            d3.select(`#${d.idName} > text`)
                .text(d.areaName)
                .attr("x", d.xText())
                .attr("y", d.yText())
                .style("font-size", d.fontSize)
                .append("title")
                    .text("Clique para abrir: " + d.areaName)
        };
    }
}